export const BENCHMARK_PATHS = [
  '/:entityName/:projectName/benchmark',
  '/:entityName/:projectName/benchmark/:tab/:threadID?',
];

export const NEW_BENCHMARK_PATH = '/new-benchmark';

export const NEW_BENCHMARK_PATH_WITH_ENTITY_NAME = '/:entityName/benchmark/new';
